module.exports = __webpack_public_path__ + "img/Logo-ikon.hvid.480c781b.png";